module.exports = __webpack_public_path__ + "img/shouyered.f66e846f.svg";